import {
  DataObjectOutputType,
  DataObjectRelationEdgeType,
  DataObjectRelationNodeType,
  DataObjectType,
} from '../types';
import { z } from 'zod/v3';
import { DataObjectRelationVersionSchema } from './DataObjectVersionSchema';
import { SystemClassifierItemSchema } from '../../systemClassifier';
import { zIsoDate } from '../../common/utils';

const RelationNodeBaseSchema = z.object({
  code: z.string(),
  name: z.string(),
  dataObjectType: z.nativeEnum(DataObjectType),
  outputType: z.nativeEnum(DataObjectOutputType).nullable(),
  missingSourceData: z.boolean(),
  validationErrorLevelId: z.number().nullable(),
  calculationErrors: z.boolean(),
  hasActiveProcessing: z.boolean(),
  dataObjectGroupCode: z.string().nullable(),
  descriptionId: z.number().nullable(),
  groupId: z.number().nullable(),
  nodeType: z.nativeEnum(DataObjectRelationNodeType),
  domainName: z.string().nullable(),
  dataObjectVersions: z.array(DataObjectRelationVersionSchema).nullable(),
  activePeriods: z
    .array(
      z.object({
        validFrom: z.string().nullable(),
        validTo: z.string().nullable(),
        versionId: z.number(),
      }),
    )
    .nullable(),
  frequency: SystemClassifierItemSchema.nullable(),
  latestValueDate: zIsoDate().nullable(),
  loadingExists: z.boolean(),
  hasAccess: z.boolean(),
});

export const DataObjectRelationNodeSchema = RelationNodeBaseSchema.extend({
  childNodes: z.array(RelationNodeBaseSchema).nullable(),
});

export const DataObjectRelationEdgeSchema = z.object({
  source: z.string(),
  target: z.string(),
  relationType: z.nativeEnum(DataObjectRelationEdgeType),
});

export const DataObjectRelationsGraphDtoSchema = z.object({
  nodes: z.array(DataObjectRelationNodeSchema),
  edges: z.array(DataObjectRelationEdgeSchema),
  rootNode: z.string().nullable(),
});
